import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useThemeStore = defineStore("theme", () => {
  const isDark = ref(false);

  const initTheme = () => {
    try {
      const savedTheme = typeof localStorage !== 'undefined' ? localStorage.getItem("theme") : null;
      if (savedTheme) {
        isDark.value = savedTheme === "dark";
      } else {
        isDark.value = false;
      }
    } catch {
      isDark.value = false;
    }
    applyTheme();
  };

  const toggleTheme = () => {
    isDark.value = !isDark.value;
    applyTheme();
  };

  const applyTheme = () => {
    const theme = isDark.value ? "dark" : "light";

    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem("theme", theme);
      }
    } catch { /* ignore */ }

    try {
      if (isDark.value) {
        document.documentElement.classList.add("dark");
        document.documentElement.classList.remove("light");
      } else {
        document.documentElement.classList.add("light");
        document.documentElement.classList.remove("dark");
      }
    } catch { /* ignore DOM in tests without document */ }
  };

  watch(isDark, () => {
    applyTheme();
  });

  return {
    isDark,
    initTheme,
    toggleTheme,
    applyTheme,
  };
});
